import firebase from "../firebase/firebase";
import "firebase/firestore";
import utils from "../utils";
const db = firebase.firestore();

class ApprovalStore {
  constructor(collectionName) {
    this.collectionName = collectionName;
  }

  getApprovals(model) {
    var approvals = [];
    var approvalCollection = db.collection(this.collectionName);
    var dbModel = model;
    return new Promise(function(resolve, reject) {
      /*
        setTimeout(function() {
        
      }, 5000);
      */
      approvalCollection
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            //console.log(doc.id, ' => ', doc.data())
            dbModel = Object.assign({}, doc.data());
            dbModel.Id = doc.id;
            approvals.push(dbModel);
          });
        })
        .catch(function(error) {
          reject(error);
        });
      resolve(approvals);
    });
  }

  getApproval(Id, model) {
    var approvalCollection = db.collection(this.collectionName);
    var dbModel = model;
    return new Promise(function(resolve, reject) {
      var docRef = approvalCollection.doc(Id);
      docRef
        .get()
        .then(doc => {
          //console.log(doc.id, ' => ', doc.data())
          dbModel = Object.assign({}, doc.data());
          dbModel.Id = doc.id;
          resolve(dbModel);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  addApproval(model) {
    //console.log(model)
    var json = utils.mapDatabaseFields(model);
    var collection = this.collectionName;
    var response = { isSaved: false, error: "" };

    return new Promise(function(resolve, reject) {
      db.collection(collection)
        .add(json)
        .then(function() {
          response.isSaved = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  updateApproval(model) {
    //console.log(model)
    var json = utils.mapDatabaseFields(model);
    var collection = this.collectionName;
    var response = { isUpdated: false, error: "" };

    return new Promise(function(resolve, reject) {
      var docRef = db.collection(collection).doc(model.Id);
      docRef
        .update(json)
        .then(function() {
          response.isUpdated = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }

  deleteApproval(model) {
    var collection = this.collectionName;
    var response = { isDeleted: false, error: "" };

    if (model.Id != null) {
      return new Promise(function(resolve, reject) {
        var docRef = db.collection(collection).doc(model.Id);
        docRef
          .delete()
          .then(function() {
            response.isDeleted = true;
            resolve(response);
          })
          .catch(function(error) {
            reject(error);
          });
      });
    } else {
      return new Promise(function(resolve, reject) {
        response.error = "Approval with Id" + model.Id + " not found";
        reject(response);
      });
    }
  }

  getCollectionName() {
    console.log(this.collectionName);
  }

  async approveStudents(students) {
    var response = { isCommitted: false, error: "" };

    //create new static data for users
    // Get a new write batch
    var batch = db.batch();

    for (const index in students) {
      var studentRef = db.collection("students").doc(students[index]);
      batch.update(studentRef, { ApprovalStatus: "Approved" });
    }
    //console.log(batch);

    return new Promise(function(resolve, reject) {
      // Commit the batch
      batch
        .commit()
        .then(function() {
          response.isCommitted = true;
          resolve(response);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  }
}

export default new ApprovalStore("approvals");
